import { jsx as _jsx } from "react/jsx-runtime";
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { memo, useContext, useMemo } from 'react';
import { LegacyThermometerProvider } from './legacy';
import { ThermometerContent } from './types';
import { Z3KThermometerProvider } from './z3k';
import { VehicleThermometerProvider } from './vehicle';
export const ThermometerProvider = memo(function ThermometerProvider(props) {
    const { children, thermometer_config } = props;
    const { is_vehicle_device, is_legacy_device } = useDeviceConfig();
    const Provider = useMemo(() => {
        if (is_vehicle_device) {
            return VehicleThermometerProvider;
        }
        if (is_legacy_device) {
            return LegacyThermometerProvider;
        }
        return Z3KThermometerProvider;
    }, [is_legacy_device, is_vehicle_device]);
    return _jsx(Provider, { thermometer_config: thermometer_config, children: children });
});
export const useThermometer = () => useContext(ThermometerContent);
